/**
 * BF 레이아웃 메인 컴포넌트 - 웹빌더 통합용
 * root.tsx의 App 컴포넌트를 래핑하여 웹빌더와 연동
 */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import App from './root';

interface LayoutMainProps {
  children?: React.ReactNode;
  data?: any; // 웹빌더에서 전달하는 데이터
  previewData?: any;
  editorData?: any;
  globalMenus?: any[];
  mainMenus?: any[];
  withcookieData?: any;
  navigation?: any;
  menus?: any[];
  user?: any;
  company?: any;
}

const LayoutMain: React.FC<LayoutMainProps> = (props) => {
  const { children, ...layoutProps } = props;
  const dispatch = useDispatch();
  
  // 웹빌더 데이터를 Redux에 저장 (flone처럼)
  useEffect(() => {
    // 전체 withcookieData 구성 (globalMenus 제외)
    const fullWithcookieData = {
      ...props.withcookieData,
      mainMenus: props.mainMenus || props.withcookieData?.mainMenus || [],
      menus: props.menus || props.withcookieData?.menus || [],
      company: props.company || props.withcookieData?.company || {},
      skin: props.withcookieData?.skin || {}
    };
    
    // Redux에 저장
    dispatch({
      type: 'SET_WITHCOOKIE_DATA', 
      payload: fullWithcookieData
    });
  }, [props.withcookieData, props.mainMenus, props.menus, props.company, dispatch]);
  
  return (
    <App {...layoutProps}>
      {children}
    </App>
  );
};

export default LayoutMain;